<a (click)="handleBackButtonClick()" class="btn btn-circle" [class.no-margin]="!margin" aria-hidden="true"
    [ngClass]="extraClass"><i class="icon-left" aria-hidden="true"></i></a>